var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#D63D00"},React.createElement("g",null,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M17.5 16.19v1.75h-15v-1.75h15zM10.91 2v9.6l2.17-2.168 1.241 1.241-4.316 4.338-4.315-4.338 1.242-1.241 2.21 2.21V2h1.769z","transform":"translate(-1260 -451) translate(946 179) translate(40 269) translate(274 3)"})))))));
}

Download.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Download;

Download.default = Download;
